<section class="gallery section-padding" id="gallery">
  <div class="container text-center">
    <h2 class="title">O espaço</h2>
    <p class="subtitle">
      Uma casa nas alturas para viver momentos extraordinários.
    </p>
    <p class="description">
      Da sala principal com vista para a cidade ao terraço aberto, cada ambiente da Casa Alta foi montado para ser cenário e, ao mesmo tempo, casa: acolhedor, sofisticado e pronto para receber.
    </p>
    <p class="description">
      O espaço se adapta a diferentes formatos de eventos – jantares intimistas, coquetéis, mini weddings, encontros corporativos, lançamentos de produtos, gravações, editoriais e experiências imersivas. Você nos conta a intenção do encontro e nós desenhamos, junto com você, a melhor configuração de layout, fluxo e ambientação.
    </p>
    <p class="description">
      Aqui, cada detalhe foi pensado para que anfitriões e convidados possam simplesmente chegar, experimentar e aproveitar.
    </p>
  </div>

  <div class="carousel-wrapper">
    <div #carousel class="carousel">
      <div
        class="slide"
        *ngFor="let image of images; let i = index; trackBy: trackByIndex"
      >
        <img [src]="image" [alt]="'Foto ' + (i + 1)" />
      </div>
    </div>

    <div class="controls">
      <button class="nav prev" (click)="scrollLeft()">‹</button>
      <button class="nav next" (click)="scrollRight()">›</button>
    </div>
  </div>
</section>
